import { useEffect, useState } from "react";
import { Quotes as Quote } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export const QuoteWall = () => {
  const [wall, setWall] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/api/testimonials/wall`);
        const data = await res.json();
        if (!cancelled && data.enabled && (data.highlight || data.quotes?.length)) setWall(data);
      } catch {
        /* wall stays hidden */
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!wall) return null;
  const { highlight, quotes } = wall;

  return (
    <section data-testid="quote-wall-section" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8" style={{ background: "#FDFBF7" }}>
      <div className="max-w-5xl mx-auto">
        <p className="text-xs font-bold tracking-[0.2em] uppercase mb-3" style={{ color: "#DE3C4B", fontFamily: "Arial" }}>
          From the beta crew
        </p>
        <h2 className="text-lg md:text-lg font-bold mb-10" style={{ color: "#2A1E5C", fontFamily: "Georgia, serif" }}>
          Racers are talking 🏁
        </h2>

        {highlight && (
          <figure data-testid="quote-wall-highlight" className="mb-12 max-w-3xl">
            <Quote size={30} style={{ color: "#2E86AB" }} className="mb-4" />
            <blockquote
              className="text-2xl sm:text-3xl leading-snug italic"
              style={{ color: "#2A1E5C", fontFamily: "Georgia, serif" }}
            >
              &ldquo;{highlight.quote}&rdquo;
            </blockquote>
            {highlight.display_credit && (
              <figcaption className="mt-5 text-base font-bold" style={{ color: "#5D5A6B", fontFamily: "Arial" }}>
                <span style={{ color: "#DE3C4B" }}>, </span> {highlight.display_credit}
              </figcaption>
            )}
          </figure>
        )}

        {quotes.length > 0 && (
          <div className={`grid gap-6 ${quotes.length === 1 ? "max-w-xl" : quotes.length === 2 ? "sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
            {quotes.map((q, i) => (
              <figure
                key={i}
                data-testid={`quote-wall-card-${i}`}
                className="rounded-2xl p-6 flex flex-col justify-between"
                style={{ background: "#FFFFFF", border: "1px solid #E8E2D5", borderTop: "4px solid #2E86AB" }}
              >
                <div>
                  <Quote size={20} style={{ color: "#2E86AB" }} className="mb-3" />
                  <blockquote
                    className="text-base leading-relaxed italic"
                    style={{ color: "#2A1E5C", fontFamily: "Georgia, serif" }}
                  >
                    &ldquo;{q.quote}&rdquo;
                  </blockquote>
                </div>
                {q.display_credit && (
                  <figcaption className="mt-4 text-sm font-bold" style={{ color: "#5D5A6B", fontFamily: "Arial" }}>
                    <span style={{ color: "#DE3C4B" }}>, </span> {q.display_credit}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
